export default __webpack_public_path__ + "static/media/Sleet.6ef96c5a.png";